import ButtonGroup from '@mui/material/ButtonGroup';
import { makeThemedStyles } from '@qpr/components/utils';
import React from 'react';

const useStylesForTabs = makeThemedStyles('ToggleButtonGroup', () => ({
  ToggleButtonGroup: {}
}));

type PropType = React.ComponentProps<typeof ButtonGroup>;
export const ToggleButtonGroup: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForTabs();
  return (
    <ButtonGroup
      {...props}
      className={styles.ToggleButtonGroup}
      classes={{
        root: styles.ToggleButtonGroup
      }}
    >
      {props.children}
    </ButtonGroup>
  );
};
export default ToggleButtonGroup;
